<!-- HERO -->
<!-- overflow-hidden, sticky'i engelliyor. -->
<section class="relative pt-10 pb-12 px-4 bg-background">
    <div #contentGrid class="absolute inset-0 bg-grid-pattern opacity-15 z-0"></div>
    <!-- <div class="absolute bottom-[-10%] -left-[5%] w-[500px] h-[500px] bg-accent/15 rounded-full blur-[100px] opacity-20 z-0"></div> -->

    <div class="container mx-auto relative z-10 max-w-8xl">
        <div class="flex flex-col lg:flex-row gap-12">

            <!-- Content Column -->
            <div class="w-full lg:w-2/3 flex flex-col items-start gap-4 py-10 lg:py-20">
                <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium">
                    <span class="relative flex h-2 w-2">
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                    </span>
                    Let's Work Together !
                </div>

                <h1 class="text-5xl md:text-6xl lg:text-7xl font-display font-bold leading-[1.1] tracking-tight text-foreground">
                    Burakhan Şamlı<br />
                    <span class="text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-400 to-accent animate-gradient">
                        Computer Vision & NLP
                    </span><br />
                    AI Specialist
                </h1>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mb-0">
                    &nbsp;&nbsp;I am a Forensic Informatics Engineer with a strong interest in image processing, <strong>computer vision</strong>,
                    and GIS-based <strong>remote sensing</strong>, focused on developing practical and scalable AI-driven solutions.
                    My background includes work on biometric and identity-related systems such as <strong>facial recognition</strong> and
                    image-based identification, as well as <strong>object detection</strong>, <strong>segmentation</strong>, and <strong>tracking</strong> tasks.
                    In parallel with computer vision, I actively work with Transformer-based architectures in both vision and <strong>NLP</strong> domains,
                    aiming to stay aligned with current advances in deep learning.
                    I have experience applying these models to tasks such as image enhancement, representation learning, and
                    text-based analysis, and I continuously explore emerging methods and architectures to strengthen my understanding
                    of modern AI systems.
                </div>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mt-0">
                    &nbsp;&nbsp;I have also worked on satellite image analysis and GIS-focused projects, particularly involving
                    <strong>multispectral</strong> and <strong>hyperspectral</strong> data for agriculture-oriented &nbsp;applications
                    such as land use and land cover (LULC) analysis. Across my projects, I integrate machine learning models into deployable
                    software systems, working with containerized and <strong>microservice-based</strong> architectures using tools
                    such as <strong>Docker</strong> and <strong>Kubernetes</strong>, and remain motivated to learn, adapt, and contribute
                    to real-world projects where data-driven solutions create measurable impact.
                </div>

                <div class="flex flex-col sm:flex-row items-center gap-6 mt-4 w-full sm:w-auto">
                    <a routerLink="/projects" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 bg-primary text-primary-foreground 
									 shadow-[0_10px_20px_-10px_rgba(var(--primary),0.5)]
									 transition-all duration-300 
									 hover:shadow-[0_20px_30px_-10px_rgba(var(--primary),0.6)]
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span>View Projects</span>
                            <span class="transition-transform duration-300 group-hover:translate-x-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 12h14m-7-7 7 7-7 7" />
                                </svg>
                            </span>
                            <div class="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
                        </button>
                    </a>

                    <a routerLink="/blog" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 border-2 border-border bg-background/50 backdrop-blur-sm text-foreground
									 transition-all duration-300 
									 hover:border-primary/50 hover:bg-primary/5
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span class="transition-transform duration-300 group-hover:-rotate-12">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
                                    <path d="M8 7h6" />
                                    <path d="M8 11h8" />
                                </svg>
                            </span>
                            <span>Read Articles</span>
                            <div class="absolute bottom-2 left-8 right-8 h-[1px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                        </button>
                    </a>

                </div>
            </div>

            <!-- Fingerprint Column - Sticky (Desktop only) -->
            <div class="hidden lg:block lg:w-1/3 py-20">
                <div class="sticky top-24">
                    <div class="flex items-center justify-center relative">
                        <div class="size-72 bg-gradient-to-br from-primary/30 to-accent/30 rounded-full blur-[90px] absolute animate-pulse"></div>
                        <div class="relative z-10 p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl flex items-center justify-center overflow-hidden group">
                            <div class="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <lucide-icon [img]="FingerprintPatternIcon" class="size-48 text-primary opacity-90 relative z-10 transition-transform duration-700 group-hover:scale-110"></lucide-icon>

                            <div class="absolute top-2 left-2 size-4 border-t-2 border-l-2 border-primary/30"></div>
                            <div class="absolute bottom-2 right-2 size-4 border-b-2 border-r-2 border-primary/30"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- SKILLS -->
<section class="py-12 relative overflow-hidden bg-background">
  <div class="container mx-auto px-6">

    <!-- Başlık -->
    <div class="mb-10">
      <h2 class="text-2xl font-display font-bold flex items-center gap-3">
        <span class="text-primary">/</span>Technical Skills & Expertise
      </h2>
      <hr class="mt-4 border-border">
    </div>

    <!-- ANA GRID -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

      <!-- SOL SÜTUN – TEXT / PROSE -->
      <div class="space-y-10">

        <div class="prose lg:prose-lg text-muted-foreground">
          <h4>AI & Computer Vision</h4>
          <ul>
            <li>Experience in developing AI-based image processing and computer vision applications, including OpenCV-based systems, OCR, image segmentation, object detection and tracking, and dataset preparation and labeling.</li>
            <li>Hands-on work with GAN and Transformer-based image enhancement techniques, including super-resolution and representation learning approaches.</li>
            <li>Development and deployment of real-time AI systems, such as quality control solutions, face recognition and identification platforms, and infrastructure inspection projects, including high-voltage transmission line fault detection.</li>
            <li>Deep learning model development primarily using PyTorch, with experience in inference and serving frameworks such as Triton Inference Server and TorchServe.</li>
          </ul>
        </div>

        <div class="prose lg:prose-lg text-muted-foreground">
          <h4>NLP & Transformer Architectures</h4>
          <ul>
            <li>Practical experience with Transformer-based architectures across both computer vision and natural language processing domains.</li>
            <li>Exposure to text-based analysis, feature representation, and modern deep learning workflows aligned with current advances in Transformer models.</li>
          </ul>
        </div>

        <div class="prose lg:prose-lg text-muted-foreground">
          <h4>Remote Sensing & GIS</h4>
          <ul>
            <li>Experience in satellite image analysis and GIS-based workflows using multispectral and hyperspectral data.</li>
            <li>Application of remote sensing techniques to agriculture-oriented projects, including Land Use and Land Cover (LULC) analysis.</li>
            <li>Hands-on experience with platforms and tools such as Sentinel, Landsat, Google Earth Engine, ArcGIS Pro, and EU Copernicus datasets.</li>
            <li>Applied knowledge of satellite image preprocessing, analysis, and interpretation for real-world GIS applications.</li>
          </ul>
        </div>

        <div class="prose lg:prose-lg text-muted-foreground">
          <h4>Software Engineering & Deployment</h4>
          <ul>
            <li>Web application development using ASP.NET Core/Angular, with a focus on backend-oriented system design.</li>
            <li>Design and implementation of microservice-based architectures for scalable software systems.</li>
            <li>Experience with Docker, Kubernetes, and Proxmox.</li>
            <li>CI/CD pipelines using GitHub Actions, GHCR, ArgoCD, and Ansible.</li>
            <li>Real-time data processing with Kafka, Redis, and RTMP.</li>
            <li>Monitoring with Prometheus and Grafana.</li>
          </ul>
        </div>

        <div class="prose lg:prose-lg border-l-2 border-primary/50 pl-4 py-2 bg-primary/5 rounded-r">
          <p class="font-medium">Specialized Research & Advanced Systems</p>
          <ul>
            <li>Remote sensing research for environmental and agricultural use cases.</li>
            <li>Real-time sports performance analysis (motion & posture).</li>
            <li>AI training on Huawei Atlas 800 (NPU acceleration).</li>
          </ul>
        </div>

      </div>

      <!-- SAĞ SÜTUN – SKILLS -->
      <div class="space-y-14 lg:sticky lg:top-24">

        <!-- Intelligence -->
        <div class="space-y-6">
          <div class="flex items-center gap-4">
            <div class="h-px flex-grow bg-border"></div>
            <h3 class="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Intelligence
            </h3>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <app-skill-badge
              *ngFor="let skill of aiSkills()"
              [skill]="skill" />
          </div>
        </div>

        <!-- Frameworks -->
        <div class="space-y-6">
          <div class="flex items-center gap-4">
            <div class="h-px flex-grow bg-border"></div>
            <h3 class="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Frameworks
            </h3>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <app-skill-badge
              *ngFor="let skill of devSkills()"
              [skill]="skill" />
          </div>
        </div>

        <!-- Tools -->
        <div class="space-y-6">
          <div class="flex items-center gap-4">
            <div class="h-px flex-grow bg-border"></div>
            <h3 class="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Tools
            </h3>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <app-skill-badge
              *ngFor="let skill of toolSkills()"
              [skill]="skill" />
          </div>
        </div>

        <!-- Other -->
        <div class="space-y-6">
          <div class="flex items-center gap-4">
            <div class="h-px flex-grow bg-border"></div>
            <h3 class="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Other
            </h3>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <app-skill-badge
              *ngFor="let skill of otherSkills()"
              [skill]="skill" />
          </div>
        </div>

      </div>

    </div>
  </div>
</section>


<!-- PROJECTS -->
<section class="py-24 px-4">
    <div class="container mx-auto px-6">
        <div class="flex flex-col md:flex-row items-end mb-8">
            <h4 class="text-2xl font-display font-bold flex items-center gap-3">
                <span class="text-primary">&</span>Featured Projects
            </h4>
        </div>
        <hr>
        <br>
    </div>


    <div class="container mx-auto">

        <ng-container *ngIf="projectsLoading(); else projectsLoaded">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div *ngFor="let i of [1,2,3]" class="h-96 rounded-2xl bg-muted animate-pulse"></div>
            </div>
        </ng-container>

        <ng-template #projectsLoaded>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <app-project-card *ngFor="let project of featuredProjects()" [project]="project" />
            </div>
        </ng-template>
        <br>
        <a routerLink="/projects" class="group w-full sm:w-auto">
            <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 bg-primary text-primary-foreground 
									 shadow-[0_10px_20px_-10px_rgba(var(--primary),0.5)]
									 transition-all duration-300 
									 hover:shadow-[0_20px_30px_-10px_rgba(var(--primary),0.6)]
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                <span>View All Projects</span>
                <span class="transition-transform duration-300 group-hover:translate-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14m-7-7 7 7-7 7" />
                    </svg>
                </span>
                <div class="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
            </button>
        </a>
    </div>
</section>